module.exports = __webpack_public_path__ + "img/story044@2x.27ea7564.webp";